"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../map.component");
const _4d_mapper_1 = require("4d-mapper");
const core_2 = require("@ngx-translate/core");
const BaseComponent_1 = require("../../../commons/BaseComponent");
const map_service_1 = require("../../../commons/map.service");
const vasat_1 = require("vasat");
const operators_1 = require("rxjs/operators");
const index_1 = require("rxjs/index");
const app_service_1 = require("../../../commons/app.service");
const common_1 = require("@angular/common");
const embed_code_dialog_1 = require("@src/app/commons/dialogs/embed-code-dialog");
const Cesium = window.Cesium;
class ShareComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, snackBar, dialog, location, mapComp, mapService, trans, fourD, service) {
        super(router, snackBar, dialog);
        this.route = route;
        this.router = router;
        this.location = location;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.trans = trans;
        this.fourD = fourD;
        this.service = service;
        this.users = [];
        this.maxSharesReached = false;
        /* Shaz quick n dirty version, Alex please transplant to a better place as needed */
        this.roleGroups = [];
        mapService.onReady().subscribe(s => this.refresh());
        mapComp.activeDetails = this;
        if (!mapComp.activeTab)
            mapComp.setTab('layers');
        mapComp.detailsNav.open();
        this.userRolesInit();
    }
    cancel() {
        this.navigateBack(this.location);
    }
    refresh() {
        this.users = [];
        this.fourD.activeTeam.accountGroups.queryObservable().pipe(operators_1.map(res => this.groups = res.items), operators_1.mergeMap(res => {
            let usersQueryObs = [];
            // Go through all AccessGroups and get the users obeservable and attach them to a forkJoin
            for (var i = 0; i < this.groups.length; i++) {
                let group = this.groups[i];
                if (group.uid.indexOf('_admins') !== -1) {
                    usersQueryObs.push(group.users.queryObservable().pipe(operators_1.map(i => group['cachedUsers'] = i.items)));
                }
            }
            return index_1.forkJoin(usersQueryObs);
        }), operators_1.map(result => {
            this.users = [];
            // Go through all the users list results and append them to the global users array.
            for (var i = 0; i < result.length; i++) {
                let ele = result[i];
                ele.forEach(u => {
                    if (this.userIndex(this.users, u) == -1)
                        this.users.push(u);
                });
            }
            this.mapService.currentProject.shareUsers.queryObservable().subscribe(shareUsers => {
                shareUsers.items.forEach(u => {
                    if (this.userIndex(this.users, u) == -1)
                        this.users.push(u);
                });
                this.users.sort((a, b) => a.name.localeCompare(b.name));
            });
        })).subscribe();
    }
    userIndex(list, user) {
        var index = -1;
        for (var i = 0; i < list.length; i++) {
            let u = list[i];
            if (u.id == user.id)
                index = i;
        }
        return index;
    }
    invite() {
        this.trans.get('SIGNIN.EMAIL').subscribe(email => {
            var v = { placeholder: email };
            let camera = {};
            if (this.mapService.viewer) {
                camera = {
                    position: {
                        lat: Cesium.Math.toDegrees(this.mapService.viewer.camera.positionCartographic.latitude),
                        lng: Cesium.Math.toDegrees(this.mapService.viewer.camera.positionCartographic.longitude),
                        height: this.mapService.viewer.camera.positionCartographic.height
                    },
                    direction: {
                        heading: Cesium.Math.toDegrees(this.mapService.viewer.camera.heading),
                        pitch: Cesium.Math.toDegrees(this.mapService.viewer.camera.pitch),
                        roll: Cesium.Math.toDegrees(this.mapService.viewer.camera.roll)
                    }
                };
            }
            var inp = {
                permissions: [{ key: 'inspect', value: true }, { key: 'measure', value: true }, { key: 'download', value: false }, { key: 'see_disabled_layers', value: false }, { key: 'see_all_scenes', value: false }]
            };
            this.maxSharesReached = false;
            this.openDialog('SHARES.NAME', null, 'SHARES.INVITE', 'GENERIC.CANCEL', inp).subscribe(dialog => {
                // ONLY add share if user has provided an email or name otherwise it will generate an empty entry on the backend
                if (dialog.name || dialog.email) {
                    this.mapService.addShare(dialog, camera).subscribe(s => {
                        //used when shared link is clicked
                        this.mapService.currentProject['lastActiveScene'] = this.mapService.scene.id;
                        this.mapService.currentProject.saveObservable().subscribe();
                        this.refresh();
                        this.trans.get('SHARES.INVITED', { email: s }).subscribe();
                    }, e => {
                        if (e.status === 4301) {
                            this.maxSharesReached = true;
                        }
                    });
                }
            });
        });
    }
    rm(c) {
        this.openDialog('SHARES.DELETE', 'SHARES.DELETE_TEXT', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
            if (s) {
                this.mapService.removeShare(c)
                    .subscribe(s => {
                    this.trans.get('SHARES.DEL', { email: s }).subscribe();
                    this.maxSharesReached = false;
                }, e => this.openSnackBarError(e.message));
            }
        });
    }
    cp(c) {
        // get the value
        let val = this.getLink(c);
        const listener = function (ev) {
            ev.preventDefault();
            ev.clipboardData.setData('text/plain', val);
        };
        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
        // assume success
        this.openSnackBarSuccess('GENERIC.COPIED');
    }
    embed(c) {
        console.info(c);
        let dialogRef = this.dialog.open(embed_code_dialog_1.EmbedCodeDialog, {
            width: '600px',
            height: '300px',
            data: {
                url: this.getLink(c)
            }
        });
        return dialogRef.afterClosed();
    }
    getLink(c) {
        return 'https://' + location.hostname + '/auth/share/' + c.token + '/' + c.secret;
    }
    clickedMap(movement, rightClick, checkedPosition) {
        // console.log ( 'share.comp :: clickedMap()');
        if (rightClick) {
            this.mapComp.detailsNav.close();
            this.router.navigate(['/app/projects/map', this.mapService.currentProject.id, 'layers']);
        }
        return map_component_1.ClickDisplay.None;
    }
    userRolesInit() {
        this.mapService.onReady().subscribe(_ => this.userRolesRefresh());
    }
    userRolesRefresh() {
        this.fourD.V.get('/api/Project/' + this.mapService.currentProject.id + '.acl').subscribe(res => this.roleGroups = res.payload);
    }
    addUserTo(uid, user) {
        this.fourD.V.put('/api/Project/' + this.mapService.currentProject.id + '.acl/' + uid + '/' + user.id, {}).subscribe(_ => this.userRolesRefresh());
    }
    removeUserFrom(uid, user) {
        this.openConfirmDelete(() => this.fourD.V.delete('/api/Project/' + this.mapService.currentProject.id + '.acl/' + uid + '/' + user.id).subscribe(_ => this.userRolesRefresh()), 'Remove ' + user.name + ' from this role?');
    }
    currentSceneFilter(sharedClient) {
        return sharedClient["activeSceneId"] == this.mapService.scene.id;
    }
}
exports.ShareComponent = ShareComponent;
